import { createFileRoute, retainSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@/lib/zod-adapter';
// import { alertBannerQueryOptions } from '@/services/queryOptions/alertBannerQueryOptions';
// import { baselineNavigationQueryOptions } from '@/services/queryOptions/baselineNavigationQueryOptions';
// import { footerDownloadAppQueryOptions } from '@/services/queryOptions/footerDownloadAppQueryOptions';
// import { footerNavigationQueryOptions } from '@/services/queryOptions/footerNavigationQueryOptions';
import { primaryNavigationQueryOptions } from '@/services/queryOptions/primaryNavigationQueryOptions';
import { rootSearchSchema } from '@/schemas/search-params';
import Home from '@/pages/home';
import { processSQSearch } from '@/utils/loader';
import { PAGE_KEY } from '@/constants/page.constants';
import { pageContentQueryOptions } from '@/services/queryOptions/pageContentQueryOptions';

export const Route = createFileRoute('/_layout/')({
  validateSearch: zodValidator(rootSearchSchema),
  search: {
    middlewares: [retainSearchParams(['conversation_id', 'agent-token'])],
  },
  beforeLoad({ search }) {
    const parsedSearch = rootSearchSchema.safeParse(search);
    if (!parsedSearch.success) {
      //TODO: Log to Sentry
      console.error('Invalid search parameters: ', parsedSearch.error);
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context;
    const fetchPromises = [];

    // Prefetch navigation data
    // fetchPromises.push(
    //   queryClient.prefetchQuery(baselineNavigationQueryOptions)
    // );
    // fetchPromises.push(queryClient.prefetchQuery(footerNavigationQueryOptions));
    fetchPromises.push(
      queryClient.prefetchQuery(primaryNavigationQueryOptions)
    );
    // fetchPromises.push(
    //   queryClient.prefetchQuery(footerDownloadAppQueryOptions)
    // );
    //fetchPromises.push(queryClient.prefetchQuery(alertBannerQueryOptions));
    const homePageKey = PAGE_KEY['/'];
    fetchPromises.push(
      queryClient.prefetchQuery(pageContentQueryOptions(homePageKey))
    );
    await Promise.allSettled(fetchPromises);

    processSQSearch(queryClient);
  },
  component: () => <Home />,
});
